import { takeLeading, call, put, select } from "redux-saga/effects";
import {
  teachersSetAll,
  teacherAddOne,
  teacherRemoveOne,
  removeChosenTeacher,
  teacherUpdateOne,
} from "../slices/teachers.slice.js";
import { loadingEdit, errorEdit } from "../slices/status.slice";
import { teachersService } from "../../services";
import { modalEdit, contentEdit } from "../slices/modal.slice.js";
import { getAll as getAllStyles } from "./styles.saga";

export function* getAll(action) {
  const response = yield call(teachersService.getAll, {
    userId: action.payload.userId,
  });
  yield put(teachersSetAll(response.data));
}

function* addOne(action) {
  yield put(loadingEdit(true));
  try {
    const response = yield call(teachersService.create, action.payload);
    const allLevels = yield select((state) => state.levels.entities);
    const allStyles = yield select((state) => state.styles.entities);

    const teacherAndlevels =
      action.payload.levelsId?.map((levelId) => ({
        levelId: levelId,
        level: allLevels[levelId]
          ? { levelName: allLevels[levelId].levelName }
          : null,
      })) || [];

    const teacherAndstyles =
      action.payload.stylesId?.map((styleId) => ({
        styleId: styleId,
        style: allStyles[styleId]
          ? { styleName: allStyles[styleId].styleName }
          : null,
      })) || [];

    yield put(
      teacherAddOne({
        id: response.data.teacher.id,
        teacherName: action.payload.teacherName,
        teacherColor: action.payload.teacherColor,
        availabilityTime: action.payload.availabilityTime,
        teacherAndstyles: teacherAndstyles,
        teacherAndlevels: teacherAndlevels,
      })
    );

    yield put(contentEdit("New teacher has been created"));
    yield put(modalEdit("Confirm"));
  } catch (error) {
    if (error.response) {
      const msg = error.response.data?.message || JSON.stringify(error.response.data) || 'Server error (' + error.response.status + ')';
      yield put(errorEdit(msg));
    } else if (error.message) {
      yield put(errorEdit('Client error: ' + error.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

function* updateOne(action) {
  yield put(loadingEdit(true));
  try {
    yield call(teachersService.update, action.payload);
    const allLevels = yield select((state) => state.levels.entities);
    const allStyles = yield select((state) => state.styles.entities);

    const teacherAndlevels =
      action.payload.levelsId?.map((levelId) => ({
        levelId: levelId,
        level: allLevels[levelId]
          ? { levelName: allLevels[levelId].levelName }
          : null,
      })) || [];

    const teacherAndstyles =
      action.payload.stylesId?.map((styleId) => ({
        styleId: styleId,
        style: allStyles[styleId]
          ? { styleName: allStyles[styleId].styleName }
          : null,
      })) || [];

    yield put(
      teacherUpdateOne({
        teacherId: action.payload.teacherId,
        teacherName: action.payload.teacherName,
        teacherAndstyles: teacherAndstyles,
        teacherAndlevels: teacherAndlevels,
        availabilityTime: action.payload.availabilityTime,
        teacherColor: action.payload.teacherColor,
      })
    );

    yield put(removeChosenTeacher());
    yield call(getAllStyles, { payload: { userId: action.payload.userId } });
    yield put(contentEdit("The teacher has been updated"));
    yield put(modalEdit("Confirm"));
  } catch (error) {
    if (error.response) {
      const msg = error.response.data?.message || JSON.stringify(error.response.data) || 'Server error (' + error.response.status + ')';
      yield put(errorEdit(msg));
    } else if (error.message) {
      yield put(errorEdit('Client error: ' + error.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

function* removeOne(action) {
  yield put(loadingEdit(true));
  try {
    yield call(teachersService.delete, {
      teacherId: action.payload.teacherId,
      userId: action.payload.userId,
    });
    yield put(teacherRemoveOne(action.payload.teacherId));
    yield put(removeChosenTeacher());
    yield call(getAllStyles, { payload: { userId: action.payload.userId } });
    yield put(contentEdit("The teacher has been deleted"));
    yield put(modalEdit("Confirm"));
  } catch (error) {
    if (error.response) {
      const msg = error.response.data?.message || JSON.stringify(error.response.data) || 'Server error (' + error.response.status + ')';
      yield put(errorEdit(msg));
    } else if (error.message) {
      yield put(errorEdit('Client error: ' + error.message));
    } else {
      yield put(errorEdit("Something has gone wrong. Please try again later"));
    }
  } finally {
    yield put(loadingEdit(false));
  }
}

export default function* watchTeachersSaga() {
  yield takeLeading("TEACHERS_GET_ALL", getAll);
  yield takeLeading("TEACHER_ADD_ONE", addOne);
  yield takeLeading("TEACHER_UPDATE_ONE", updateOne);
  yield takeLeading("TEACHER_REMOVE_ONE", removeOne);
}
